import ItemCreator from './ItemCreator';
import RecordTypes, { DIRECTORIES } from './RecordTypes';
import { FILESYSTEM_NAME, FILESYSTEM_PARENT_DIRECTORY } from './Filesystem';

const emptyRecordTypeMap = () => Object.fromEntries(RecordTypes.map(type => ([type,{}]))); 

export default function createDefaultStateItems(args={},state){

  const items = {
    data:emptyRecordTypeMap(),
    meta:emptyRecordTypeMap()
  }

  let { datatypeSpecificDirectoryRoots,creationContext={} } = args;

  injectDefaultItemTypeRootDirectoryItemsIntoItems({
    items,
    itemTypeRootDirectoryIdMap:datatypeSpecificDirectoryRoots,
    state,
    creationContext,
  });

  return items;

}

function injectDefaultItemTypeRootDirectoryItemsIntoItems({
  items,
  itemTypeRootDirectoryIdMap,
  state,
  creationContext,
}){

    Object.entries(itemTypeRootDirectoryIdMap).forEach(([type,directoryId]) => {
    let { data, meta } = ItemCreator(state,{
      creationContext,

      type:DIRECTORIES,
      _id:directoryId,
      [FILESYSTEM_NAME]:(type+"-root"),
      [FILESYSTEM_PARENT_DIRECTORY]:null
    });
      items.data[DIRECTORIES][directoryId] = data;
      items.meta[DIRECTORIES][directoryId] = meta;
  })

}
